module.exports = "/_next/static/images/slide17-457907b9d89df1ff424886ad5135f49d.webp";